<script>export let format = "dd/MM/yyyy";
export let locale = navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;
export let date = new Date();
import dateFormatter from "./dateformatter.js";</script>

<span>{dateFormatter({format,locale,date})}</span>
